import { afterNextRender, computed, inject, Injectable, signal } from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { filter, map, take } from 'rxjs';
import { web } from '../environments/environment';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { MetaService } from './meta.service';

@Injectable({
  providedIn: 'root'
})
export class LocationService {
  router = inject(Router);
  private location = inject(Location);
  private translate = inject(TranslateService);
  private meta = inject(MetaService);

  isFromApp = signal<boolean>(false);
  isFromIframe = signal<boolean>(false);
  
  private _current = toSignal(this.router.events.pipe(
    filter(e => e instanceof NavigationEnd || typeof e == 'number'),
    map(e => e.url)
  ), { initialValue: '/'});
  currentURL = computed(() => new URL(web + this._current()));
  
  get current(): string {
    return this._current();
  }

  initialURL: URL = new URL(web);

  constructor() { 
    this.router.events.pipe(filter(e => e instanceof NavigationEnd), take(1)).subscribe(event => {
      this.initialURL = new URL(web + this.router.url);
      this.initialURL.searchParams.delete('token');
      this.isFromApp.set((this.initialURL?.searchParams.get('from_app')??'0') == '1');
      if(this.initialURL.searchParams.get('lang') == 'mt' || Array.from(this.initialURL.searchParams.keys()).find(key => key.toLowerCase().includes('_mlt'))){
        this.translate.use('mt');
      }
    });

    this.router.events.pipe(filter(e => e instanceof NavigationStart), takeUntilDestroyed()).subscribe(event => {
      this.meta.setTags();
    });

    if(this.meta.isBrowser && window){
      this.isFromIframe.set(window.self != window.top);

    }
  }

  navigate = this.router.navigate.bind(this.router);
  move = this.location.historyGo.bind(this.location);
  replace = this.location.replaceState.bind(this.location);
}
